import { Component, input, output } from '@angular/core';

@Component({
	selector: 'lb-survey-action',
	standalone: true,
	templateUrl: './survey-action.component.html',
	styleUrl: './survey-action.component.scss'
})
export class SurveyActionComponent {
	/** Whether the survey window is open for submission. When false, shows "Not yet available". */
	isAvailable = input<boolean>(true);
	/** Whether the current user has already submitted a response. */
	isSubmitted = input<boolean>(false);
	/** Whether the current user is the intended respondent for this survey. */
	canSubmit = input<boolean>(false);

	/** Emitted when the user clicks View Response or Complete Survey. */
	action = output<void>();
}
